import useMultiEquipmentTrackingEnabled from "hooks/settings/useMultiEquipmentTrackingEnabled/useMultiEquipmentTrackingEnabled";
import { t } from "utils/localize";

export default function useNoEquipmentName() {
  const supportsAddOns = useMultiEquipmentTrackingEnabled();

  return supportsAddOns ? t('No Primary Equipment') : t('No Equipment');
}